import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AuditFilters } from "./components/AuditFilters";
import { AuditTable } from "./components/AuditTable";
import { useAuditController } from "./useAuditController";
import { RiHistoryLine } from "react-icons/ri";

export const Audit: React.FC = () => {
  const controller = useAuditController();

  return (
    <Card className="border shadow-sm">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <RiHistoryLine className="h-5 w-5 text-primary" />
          <CardTitle>Activity Audit</CardTitle>
        </div>
        <CardDescription>
          View and monitor all activity across your organization
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <AuditFilters
          filters={controller.filters}
          updateFilters={controller.updateFilters}
          resetFilters={controller.resetFilters}
          uniqueUsers={controller.uniqueUsers}
        />

        <AuditTable
          auditLogs={controller.auditLogs}
          isLoading={controller.isLoading}
        />
      </CardContent>
    </Card>
  );
};
